import { useLingui } from '@lingui/react/macro';

import Hide from '@rover/icons/svg/hide.svg';
import { Flex } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';

import { PRIVATE_BADGE_GLYPH_SIZE, PRIVATE_BADGE_SIZE } from './constants';

// Labelled rather than captioned: a text chip would cover the photo. Shaped
// after Kibble's tertiary Badge, which the icon-only `text` prop rules out.
const GalleryPrivateBadge = (): JSX.Element => {
  const { t } = useLingui();
  const theme = useTheme();
  const label = t`Private photo`;

  return (
    <Flex
      testID="gallery-private-badge"
      width={PRIVATE_BADGE_SIZE}
      height={PRIVATE_BADGE_SIZE}
      borderRadius="secondary"
      background="tertiary"
      alignItems="center"
      justifyContent="center"
      webProps={{ role: 'img', 'aria-label': label }}
      rxnProps={{
        accessible: true,
        accessibilityRole: 'image',
        accessibilityLabel: label,
      }}
    >
      <Hide
        width={PRIVATE_BADGE_GLYPH_SIZE}
        height={PRIVATE_BADGE_GLYPH_SIZE}
        fill={theme.textColor.secondary}
      />
    </Flex>
  );
};

export default GalleryPrivateBadge;
